import TiktokPixel from 'tiktok-pixel';

import {
    Tracker,
    TrackingEvent,
    TrackerLogger,
    TrackingData,
} from '../tracking.events';

export class TiktokPixelTracker implements Tracker {
    pixelId: string = '';
    constructor(pixelId: string | null) {
        if (!pixelId) return;
        TrackerLogger.info(`Tiktok Pixel running with tracker id:`, pixelId);
        // const advancedMatching = {};
        this.pixelId = pixelId;
        TiktokPixel.init(this.pixelId, {});
    }

    sendEvent(event: TrackingEvent) {
        const { type } = event;
        switch (type) {
            /*case 'INSTALLED':
                this.onInstalled();
                break;
            case 'LOGIN':
                this.onLogin();
                break;
            case 'OPEN_TOC':
                this.onOpenToc();
                break;
            case 'CLOSE_TOC':
                this.onCloseToc();
                break;
            case 'SHARE':
                this.onShare(event.data);
                break;
            case 'BTN_CLICK_INSTALL':
                this.onClickInstall();
                break;
            case 'BTN_CLICK_LOGIN':
                this.onClickLogIn();
                break;
            case 'BTN_CLICK_LOGOUT':
                this.onClickLogOut();
                break;
            case 'BTN_CLICK_RESPONSIVE':
                this.onClickResponsive(event.data);
                break;
            case 'BTN_CLICK_REPLICA':
                this.onClickReplica(event.data);
                break;
            case 'BTN_CLICK_REPLICA_SINGLE':
                this.onClickReplicaSingle(event.data);
                break;
            case 'BTN_CLICK_REPLICA_DOUBLE':
                this.onClickReplicaDouble(event.data);
                break;
            case 'BTN_CLICK_FAVORITE_ARTICLE':
                this.onClickFavoriteArticle(event.data);
                break;
            case 'BTN_CLICK_UNFAVORITE_ARTICLE':
                this.onClickUnfavoriteArticle(event.data);
                break;
            case 'BTN_CLICK_ISSUE':
                this.onClickIssue(event.data);
                break;
            case 'LANGUAGE_CHANGE':
                this.onChangeLanguage(event.data);
                break;*/
            default:
                return;
        }
    }

    private onInstalled() {
        TiktokPixel.track('Installed', {
            category: 'app',
            nonInteraction: true,
        });
    }

    private onLogin() {
        TiktokPixel.track('Login', {
            category: 'session',
        });
    }

    private onOpenToc() {
        TiktokPixel.track('OpenTOC', {
            category: 'issue',
        });
    }

    private onCloseToc() {
        TiktokPixel.track('CloseTOC', {
            category: 'issue',
        });
    }

    private onShare(data: TrackingData) {
        TiktokPixel.track('Share', {
            method: data?.method,
            contentType: data?.contentType,
            itemId: data?.article?.ArticleID,
        });
    }

    private onClickInstall() {
        TiktokPixel.track('ClickInstall', {
            category: 'session',
        });
    }

    private onClickLogIn() {
        TiktokPixel.track('ClickLogin', {
            category: 'session',
        });
    }

    private onClickLogOut() {
        TiktokPixel.track('ClickLogout', {
            category: 'session',
        });
    }

    private onClickResponsive(data: TrackingData) {
        TiktokPixel.track('OnResponsive', data);
    }

    private onClickReplica(data: TrackingData) {
        TiktokPixel.track('OnReplica', data);
    }

    private onClickReplicaSingle(data: TrackingData) {
        TiktokPixel.track('OnSingleReplica', data);
    }

    private onClickReplicaDouble(data: TrackingData) {
        TiktokPixel.track('OnDoubleReplica', data);
    }

    private onClickFavoriteArticle(data: TrackingData) {
        TiktokPixel.track('OnFavoriteArticle', data);
    }

    private onClickUnfavoriteArticle(data: TrackingData) {
        TiktokPixel.track('OnUnfavoriteArticle', data);
    }

    private onClickIssue(data: TrackingData) {
        TiktokPixel.track('OpenIssue', data);
    }

    private onChangeLanguage(data: TrackingData) {
        TiktokPixel.track('ChangeLanguage', data);
    }

    static init(pixelId: string) {
        TiktokPixel.init(pixelId);
    }

    static pageView() {
        TiktokPixel.pageView();
    }
}
